import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first, map } from 'rxjs/operators';
import { AuthenticationService } from '../../../_service/authentication.service';
import { LoginModel } from '../../../_models/login-model';
import { ServiceAdapterService } from '../../../_service/service-adapter.service';
import { MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, AuthenticationResult } from '@azure/msal-browser';
import { HttpResponse } from '../../../_interface/http-response.interface';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';
  appDetails;
  azureAuthFlag: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private serviceAdapterService: ServiceAdapterService,
    private msalService: MsalService) {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });
    if (sessionStorage.hasOwnProperty('appconfig'))
      this.appDetails = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
  }
  get loginFormControl() {
    return this.loginForm.controls;
  }


  ngOnInit(): void {

    this.azureAuthFlag = (this.appDetails['azureAuthFlag'] != undefined) ? this.appDetails['azureAuthFlag'] : false;
    if (this.azureAuthFlag) {
        // Clear any active MSAL account
  this.msalService.instance.setActiveAccount(null);
      this.msalService.loginPopup({ scopes: [this.appDetails['scopes']], prompt:'select_account' }).subscribe((response: AuthenticationResult) => {
        this.msalService.instance.setActiveAccount(response.account);
        sessionStorage.setItem('userId', response.account.username)
        sessionStorage.setItem('userName', response.account.name)
        this.msalService.acquireTokenSilent({account:response.account, scopes: [this.appDetails['scopes']] }).subscribe((result: AuthenticationResult) => {
      sessionStorage.setItem('accessToken', result.accessToken)
    })
        this.router.navigateByUrl('home');
      });
    }
  }

  onSubmit() {
    this.error = "";
    this.submitted = true;
    if (this.loginForm.invalid)
      return;
    this.submitted = false;
    this.loading = true;
    this.serviceAdapterService.backendServiceCall<HttpResponse<"login", ''>>("login", this.loginForm.value).subscribe((data) => {
      this.loading = false;
      let message = data['message'];
      if (message == "Invalid Credential")
        this.error = message;
      else if (message === "User Authenticatated Successfully") {
        this.loginForm.value.userName.split("@")[0].replace(".", " ");
        sessionStorage.setItem('userId', this.loginForm.value.userName);
        sessionStorage.setItem('userName', this.loginForm.value.userName.split("@")[0].replace(".", " "));
        this.router.navigateByUrl('/home');
      }
    }, (error) => {
      this.loading = false;
    });
  }
}